import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  gap: 28px;
  height: 100vh;
  flex-direction: column;
  max-width: var(--max-width);
  margin: 0 auto;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: fit-content;
`;

export const Text = styled.div`
  color: var(--Gray-Scale-400, #bcb8c3);

  /* NEW/body_02_medium */
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 131.25% */
  letter-spacing: -0.32px;
`;

export const Tab = styled.div`
  display: flex;
  padding: 12px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;

  border-radius: 8px;
  border: 1px solid var(--bg-700, #262231);
  background: var(--bg-600, #2e2a3a);
`;

export const Required = styled.div`
  color: var(--Semantic-red, #e13a3a);

  /* NEW/body_02_medium */
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 131.25% */
  letter-spacing: -0.32px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
